
            const EMBED_ROOT_ELEMENT = "b2b-widget-embed";

            const $mountButtons = document.querySelectorAll("[data-mount-mode]");
            const $tradeInButton = document.getElementById("trade-in");
            const $unmountButton = document.getElementById("unmount");

            let widget = null;

            // Only one widget at a time, so the mount buttons are locked until unmount
            const setMounted = (mounted) => {
                $mountButtons.forEach(($button) => ($button.disabled = mounted));
                $tradeInButton.disabled = !mounted;
                $unmountButton.disabled = !mounted;
            };

            const mountWidget = (mode) => {
                const form = document.forms.settings;

                widget = window.B2BWidget.mount({
                    settings: {
                        locale: form.locale.value,
                        domain: form.domain.value,
                        mode,
                        ...(mode === "embed" && { root_element: EMBED_ROOT_ELEMENT }),
                    },
                    api: {
                        onLoad: () => console.log("[onLoad] CALLBACK"),
                        onDrop: () => console.log("[onDrop] CALLBACK"),
                        onCalc: (calcData) => console.log("[onCalc] CALLBACK", calcData),
                        onCart: (cartData) => console.log("[onCart] CALLBACK", cartData),
                    },
                });

                widget?.tradeIn();
                setMounted(Boolean(widget));
            };

            $tradeInButton.addEventListener("click", () => widget?.tradeIn());

            $mountButtons.forEach(($button) => {
                $button.addEventListener("click", () => mountWidget($button.dataset.mountMode));
            });

            $unmountButton.addEventListener("click", () => {
                widget?.unmount();
                widget = null;
                setMounted(false);
            });
        